export const MUL_WHITELISTED_COUNTRIES = [
  'Poland',

  'Czech-Republic',
  'Czech Republic',
  'Czechia',

  'Austria',
];
export const MUL_QUERY_KEY = 'useUnitType';
